<template>
    <client-page>
        <div id="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">어바웃 게시판</h2>
                </div>

                <div>
                    <h2>1 section 회사소개(고정 이미지)</h2>
                </div>

                <about-list></about-list>

                <div>
                    <h2>오시는 길(고정 이미지)</h2>
                </div>
            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import AboutList from "@/components/client/ko/board/about/list.vue"

export default {
    components: {
        ClientPage,
        AboutList
    },
};
</script>